import Fieldset from '@ux/fieldset';
import Group from '@ux/form-group';
import React from 'react';

/**
 * Render a field set with multiple grouped checkbox elements.
 *
 * @displayName CheckboxGroup (Web)
 * @class CheckboxGroup
 * @public
 */
export default class CheckboxGroup extends Group {
  /**
   * Return type of input element.
   *
   * @returns {string} input type.
   * @private
   */
  get type() {
    return 'checkbox';
  }

  /**
   * Render the group.
   *
   * @returns {ReactElement} Fieldset element.
   * @private
   */
  render() {
    const props = this.props;

    //
    // If a non-default design is desired for the component inputs
    // we need to add some attributes to the div we wrap them in.
    //
    const optional = props.design === 'base' ? {} : {
      'className': 'btn-group',
      'data-toggle': 'buttons'
    };

    return (
      <Fieldset proxy={ !!props.proxy }>
        <div role='group' aria-label='group' { ...optional }>
          { props.children }
          { this.inputs() }
        </div>
      </Fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/@ux/checkbox-group/index.js